export enum RequestStatus {
	/** Зарегистрирована */
	Registered = 1,

	/** Обрабатывается */
	InProgress = 2,

	/** Загрузка конфигурации */
	LoadConfiguration = 3,

	/** Подготовка оборудования / Ожидание протокола исследования (id совпадает с Domain.WaitingResearchProtocol) */
	DevicePreparation = 4,

	/** Ожидание протокола исследования (INBWT-906; тот же id, что DevicePreparation) */
	WaitingResearchProtocol = 4,

	/** Назначено на СЦ */
	Assigned = 5,

	/** Выполнение работ */
	InWork = 6,

	/** Работы выполнены */
	WorkCompleted = 7,

	/** На проверке */
	Verification = 8,

	/** Выполнена */
	Completed = 9,

	/** Отменена */
	Cancelled = 10,

	/** Остановлена */
	Stopped = 11,

	/** Технический запрос */
	TechnicalRequest = 12,

	/** Отправка товаров */
	ProductSending = 13,

	/** Товар отправлен */
	ProductSended = 14,

	/** Подготовка задания на испытания */
	TrialTaskPreparation = 15,

	/** Проведение испытаний */
	TrialExecution = 16,

	/** Испытания завершены */
	TrialsCompleted = 17,

	/** Корректировка протокола испытаний */
	TrialProtocolAdjustment = 18,

	/** Отбор проб */
	Sampling = 19,

	/** Задание на отбор проб */
	SamplingTask = 20,

	/** Оформление документов */
	Paperwork = 21,

	/** Согласование визита */
	VisitCoordination = 22,

	/** Ожидает прибытия */
	AwaitingArrival = 33,
}
